import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify';

import auth from "@/auth"

Vue.use(auth)

Vue.config.productionTip = false

async function start() {
  let router;
  try {
    await Vue.prototype.$auth.signIn();
    // Keycloak must finish processing the callback URL before the router starts.
    router = (await import('./router')).default;
  } catch (error) {
    Vue.prototype.$auth.fail('Unable to sign in. Please try again.');
  }

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app');
}

start();
